import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const getPicklistsApi = (query) =>
  api.get(`/Picklists?${queryToString(query)}`).then((res) => res.data);

export const getFilterCriteriaApi = () =>
  api.get(`/Picklists/FilterCriteria`).then((res) => res.data);

export const getLocationsApi = (query) =>
  api.get(`/Locations/ShortedWithSublocations?${queryToString(query)}`).then((res) => res.data);

export const getStatusesApi = () => api.get('/PicklistStatuses').then((res) => res.data);

export const getProjectsApi = (query) =>
  api.get(`/ShortedProjects?${queryToString(query)}`).then((res) => res.data);

export const createPicklistApi = (params) => api.post('/Picklist', params).then((res) => res.data);

export const updatePicklistApi = (params) => api.put('/Picklist', params).then((res) => res.data);

export const getAssetStatusesListApi = (q) =>
  api.get(`/PicklistAssetStatuses?${queryToString(q)}`).then((res) => res.data);

export const getListOfPicklistApi = () => api.get('/ShortedPicklists').then((res) => res.data);

export const getSummaryCsvResourceApi = (q) =>
  api.get(`/Picklists/Serialized?${queryToString(q)}`).then((res) => res.data);
